import(/* webpackMode: "eager" */ "/app/src/app/language/[code]/alphabet/practice/page.tsx");
